let locationSelector

function vueLocationSelector() {
    locationSelector = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const storeSelector = window.storeSelector()

            if (localStorage.getItem('currentUserLocation')) {
                storeSelector.updateLocation(JSON.parse(localStorage.getItem('currentUserLocation')));
            }

            if (localStorage.getItem('currentNearestStore')) {
                storeSelector.updateNearestStore(JSON.parse(localStorage.getItem('currentNearestStore')));
            } else {
                storeSelector.geolocation()
            }

            const locationSearch = Vue.ref('')
            const searchOpen = Vue.ref(false)
            const buttonOpen = Vue.ref(false)
            const subset = Vue.ref(false)
            const postsubset = Vue.ref(false)
            const showStoreList = Vue.ref(false)

            const toggleAccordion = () => {
                if (!storeSelector.nearestStore) {
                    showSearchBox()
                } else {
                    buttonOpen.value = !buttonOpen.value
                }
            }

            const getStoreLink = (store) => {
                const node = store?.node || store
                if (!node?.name) return '#'
                if (node.storeLink) return node.storeLink
                const slug = String(node.name)
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, '-')
                    .replace(/-$/, '')
                    .replace(/^-/, '')
                return `${shopifyConfig.storeURL}/pages/${slug}-t-marts`
            }

            const showSearchBox = () => {
                storeSelector.getLocationInfo().then(([postcodes, suburbs]) => {
                    searchOpen.value = true
                    showStoreList.value = false
                    buttonOpen.value = true
                    Vue.watch(locationSearch, (newInput, oldInput) => {
                        if(newInput.length < oldInput.length) {
                            subset.value = false
                            postsubset.value = false
                            showStoreList.value = false
                        }
                        storeSelector.inputListener(newInput, subset, postsubset, postcodes, suburbs)
                    })
                })
            }

            const headerLocationSelect = (loc) => {
                if(loc.postcode) {
                    storeSelector.locationSelect(loc.postcode, loc.latitude, loc.longitude)
                } else {
                    storeSelector.locationSelect(`${loc.item.name}, ${loc.item.state}`, loc.item.latitude, loc.item.longitude)
                }
                subset.value = false
                postsubset.value = false
                showStoreList.value = true
                searchOpen.value = true
            }

            const chooseStore = (index) => {
                storeSelector.storeSelect(index)
                showStoreList.value = false
                buttonOpen.value = false
                searchOpen.value = false
                locationSearch.value = ''
            }
            
            const locationShow = Vue.computed(() => {
                return storeSelector.nearestStore && !searchOpen.value ? true : false
            })

            const showSuburbList = Vue.computed(() => {
                return searchOpen.value && subset.value && !showStoreList.value ? true : false
            })

            const showPostcodeList = Vue.computed(() => {
                return searchOpen.value && postsubset.value && !showStoreList.value ? true : false
            })


            return {
                searchOpen, 
                toggleAccordion, 
                showSearchBox, 
                locationSearch, 
                locationShow, 
                buttonOpen, 
                subset, 
                postsubset,
                headerLocationSelect, 
                storeSelector,
                getStoreLink,
                showStoreList,
                chooseStore,
                showSuburbList,
                showPostcodeList
            };
        }
    })
    locationSelector.use(window.VueAppGlobals.pinia);
    locationSelector.mount('#store-selector');
}

if (window.Vue && window.Pinia) {
    vueLocationSelector();
} else {
    window.addEventListener('vue-ready', vueLocationSelector);
}
